/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-calculator': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.25 2.5v15H3.75v-15h12.5zm0-1.25H3.75c-.69 0-1.25.56-1.25 1.25v15c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-15c0-.69-.56-1.25-1.25-1.25zM5.625 14.375h1.25v1.25h-1.25v-1.25zm7.5 0h1.25v1.25h-1.25v-1.25zm-7.5-3.125h1.25v1.25h-1.25v-1.25zm7.5 0h1.25v1.25h-1.25v-1.25zm-7.5-3.125h1.25v1.25h-1.25v-1.25zm3.75 6.25h1.25v1.25h-1.25v-1.25zm0-3.125h1.25v1.25h-1.25v-1.25zm0-3.125h1.25v1.25h-1.25v-1.25zm3.75 0h1.25v1.25h-1.25v-1.25zm-7.5-3.75h8.75V6.25h-8.75V4.375z"/>'
  }
})
